import { useState, useEffect, useRef, MouseEventHandler } from "react";
import { Dropdown } from "react-bootstrap";
import "./photo.scss";
import iconPencil from "src/assets/icons/icon-edit.svg";
import { Typography } from "src/latest/src/components";
import { QuestionsUniqueKeys } from "src/containers/QuestionnaireParent/QuestionnaireEnum";

interface Props {
    onProfileChangeClick: MouseEventHandler<HTMLElement>;
    removeImage: MouseEventHandler<HTMLElement>;
    size?: 'm' | 'l';
    questionData?: any;
    isDirectoryPlatform?: boolean;
}

export const OptionDropdown = ({
    onProfileChangeClick,
    removeImage,
    size,
    questionData,
    isDirectoryPlatform = false,
}: Props) => {
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const uniqueKey = questionData?.unique_key;
    const isQuestionRequired = questionData?.required;

    const handleToggleDropdown = () => {
        setDropdownVisible(!dropdownVisible);
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target as Node)
        ) {
            setDropdownVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div ref={dropdownRef}>
            <Dropdown show={dropdownVisible}>
                <Dropdown.Toggle
                    as={"div"}
                    id="dropdown-basic-default"
                    className={`remove-image-button ${dropdownVisible ? "pencil-display" : ""} remove-image-button-size-${size}`}
                    onClick={handleToggleDropdown}
                >
                    <img src={iconPencil} alt="remove icon" />
                </Dropdown.Toggle>

                <Dropdown.Menu align={"start"}>
                    <Dropdown.Item onMouseDown={onProfileChangeClick}>
                        <Typography
                            color="color-4"
                            variant="size-16"
                            weight="regular"
                        >
                            Change Profile Image
                        </Typography>
                    </Dropdown.Item>
                    {
                        isDirectoryPlatform && uniqueKey === QuestionsUniqueKeys.inPersonOfficePictureQuestion && isQuestionRequired  ? <></> : (
                            <Dropdown.Item onMouseDown={removeImage}>
                                <Typography
                                    color="color-6"
                                    variant="size-16"
                                    weight="regular"
                                >
                                    Remove Profile Image
                                </Typography>
                            </Dropdown.Item>
                        )
                    }
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};
